// This import loads the firebase namespace along with all its type information.
import ProfileComment from './profile-comment-model'

export async function load_profileComments(): Promise<ProfileComment[]> {
  throw 'Not implemented'
}

export async function delete_profileComment(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_profileComment(): Promise<ProfileComment> {
  throw 'Not implemented'
}
